const initialState = {
    user: null
};

const AuthReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SUCCESS_LOGIN':
            return {
                ...state,
                user: action.payload
            };
        case 'SUCCESS_LOGOUT':
            return {
                ...state,
                user: null
            };
        default:
            return state;
    }
}

export default AuthReducer;